var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeaderCrossIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon header-cross-icon",
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.196.147L1.28.22 8 6.939l6.72-6.72a.75.75 0 011.133.977l-.072.084L9.06 8l6.72 6.72a.75.75 0 01-.977 1.133l-.084-.073L8 9.061l-6.72 6.72a.75.75 0 01-1.133-.977l.073-.084L6.939 8 .219 1.28A.752.752 0 011.197.147z",
    fill: "#4D4D4D"
  })));
}

export default SvgHeaderCrossIconSv;